$('.mask').on('click', function() {
  $('#menu').removeClass('active');
  $('#search').removeClass('active');
  $('.menu-list').removeClass('menu-list--open');
  $('.search').removeClass('search--open')
  $('.mask').css('z-index', 1).fadeOut(400);
  fullpage_api.setAllowScrolling(true);
  $('body').css('overflow', 'visible');
})